import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Games() {
  return <ImageCollectionPage title="Games" path="/culture/games" collection="culture_games" />;
}
